import { render, staticRenderFns } from "./OrderFilter.vue?vue&type=template&id=284a1e88&"
import script from "./OrderFilter.vue?vue&type=script&lang=js&"
export * from "./OrderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports